import { get, post, put, del, patch } from '../../../../Utility/Http';
import { creditPointListingGet } from '../Model/CreditNoteModel';

export const creditPointListing = (data) => {
    return get(`${process.env.EXTENDED_URL}customer/payment/credit_point_listing`, data).then((response) => {
        return creditPointListingGet(response)
    });
};